import React from "react";
import AdminHeader from "../../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../../components/admin/AdminFooter";
import AdminTestimonialList from "../../../../views/admin/cms/testimonials/AdminTestimonialList";

const AdminTestimonialPageList = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminTestimonialList />
      <AdminFooter />
    </div>
  );
};

export default AdminTestimonialPageList;
